export function getPathByFile(file: File) {
    const {webUtils} = require('electron');
    return webUtils.getPathForFile(file);
}